import { endpoints } from "../config";
import { getData, postData } from "./api-utils";

export const userLogin = async ({ login, password }) => {
  return await postData(endpoints.login, { login, password });
};

export const checkAuth = async () => {
  return await getData(endpoints.auth);
};
